import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Tag } from 'lucide-react';
import { Button } from '@elbklar/ui';
import { customersApi } from '@/lib/api';

// MVP: hardcoded; replace with workspace setting later
const TOGGLE_TAG = 'hot';

interface TagToggleButtonProps {
  customerId: string;
  currentTags: string[];
}

export function TagToggleButton({ customerId, currentTags }: TagToggleButtonProps) {
  const qc = useQueryClient();
  const active = currentTags.includes(TOGGLE_TAG);

  const mutation = useMutation({
    mutationFn: () => {
      const nextTags = active
        ? currentTags.filter((t) => t !== TOGGLE_TAG)
        : [...currentTags, TOGGLE_TAG];
      return customersApi.update(customerId, { tags: nextTags });
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['customers', customerId] });
      qc.invalidateQueries({ queryKey: ['leads', customerId] });
    },
  });

  return (
    // Gesetzt als gedrückter Zustand in highlight-soft, nicht als zweite primary-Aktion.
    <Button
      size="sm"
      aria-pressed={active}
      className={active ? 'border-transparent bg-highlight-soft text-highlight hover:bg-highlight-soft' : undefined}
      onClick={() => mutation.mutate()}
      disabled={mutation.isPending}
      icon={Tag}
    >
      {active ? '#hot aktiv' : '#hot setzen'}
    </Button>
  );
}
